import type { PopoverReference } from "@mui/material";
import React from "react";

export const useContextMenu = () => {
  const [contextMenu, setContextMenu] = React.useState<{
    mouseX: number;
    mouseY: number;
  } | null>(null);

  const handleContextMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (
      event.ctrlKey ||
      ((event.target as HTMLElement).nodeName === "INPUT" &&
        !(event.target as HTMLInputElement).readOnly &&
        !(event.target as HTMLInputElement).disabled)
    ) {
      return;
    }
    event.preventDefault();

    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
          // Other native context menus might behave different.
          // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
          null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  return {
    onContextMenu: handleContextMenu,
    onClose: handleClose,
    menuProps: {
      anchorPosition: contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined,
      anchorReference: "anchorPosition" as PopoverReference,
      disableScrollLock: true,
      onClose: handleClose,
      open: contextMenu !== null,
      slotProps: {
        backdrop: {
          onClick: handleClose,
          onContextMenu: (e: React.MouseEvent<HTMLDivElement>) => {
            e.preventDefault();
            handleClose();
          },
        },
      },
    },
  };
};
